<template>
  <el-dialog
    title="安全验证"
    :visible.sync="visible"
    width="380px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <div class="challenge-body" v-loading="loading">
      <p class="challenge-tip">请完成安全验证后继续访问</p>
      <button
        v-if="image"
        type="button"
        class="challenge-image-button"
        title="点击刷新验证码"
        @click="loadChallenge">
        <img :src="image" alt="安全验证码" class="challenge-image" />
      </button>
      <el-input
        v-model.trim="code"
        maxlength="5"
        clearable
        autofocus
        placeholder="请输入图片中的验证码"
        @keyup.enter.native="submitChallenge">
      </el-input>
      <p v-if="errorMessage" class="challenge-error">{{ errorMessage }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelChallenge">取消</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="submitting"
        :disabled="!code"
        @click="submitChallenge">
        确认验证
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Instance, antiCrawlerBus } from "@/servers/request";

function toImageSource(image) {
  if (!image) {
    return "";
  }
  return image.indexOf("data:") === 0 ? image : `data:image/png;base64,${image}`;
}

export default {
  name: "AntiCrawlerChallenge",
  data() {
    return {
      visible: false,
      loading: false,
      submitting: false,
      image: "",
      code: "",
      errorMessage: "",
      pendingRequest: null,
    };
  },
  mounted() {
    antiCrawlerBus.$on("anti-crawler-challenge", this.openChallenge);
  },
  beforeDestroy() {
    antiCrawlerBus.$off("anti-crawler-challenge", this.openChallenge);
    this.rejectPending(new Error("安全验证已取消"));
  },
  methods: {
    openChallenge(request) {
      if (this.pendingRequest) {
        return;
      }
      this.pendingRequest = request;
      this.visible = true;
      this.code = "";
      this.errorMessage = "";
      this.loadChallenge();
    },
    async loadChallenge() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const response = await Instance.get("/sys/antiCrawler/challenge", {
          skipAntiCrawlerChallenge: true,
        });
        const result = response.data && response.data.result;
        if (!response.data || !response.data.success || !result || !result.image) {
          throw new Error("获取验证码失败");
        }
        this.image = toImageSource(result.image);
        if (result.deviceId) {
          window.localStorage.setItem("ANTI_CRAWLER_DEVICE_ID", result.deviceId);
        }
        this.pendingRequest.challengeId = result.challengeId;
        this.code = "";
      } catch (error) {
        this.errorMessage = "获取验证码失败，请点击图片重试";
      } finally {
        this.loading = false;
      }
    },
    async submitChallenge() {
      if (!this.pendingRequest || !this.code || this.submitting) {
        return;
      }
      this.submitting = true;
      this.errorMessage = "";
      try {
        const response = await Instance.post(
          "/sys/antiCrawler/verify",
          { challengeId: this.pendingRequest.challengeId, code: this.code },
          { skipAntiCrawlerChallenge: true }
        );
        if (!response.data || !response.data.success) {
          throw new Error((response.data && response.data.message) || "验证码错误");
        }
        const challengeToken = response.data.result && response.data.result.challengeToken;
        if (!challengeToken) {
          throw new Error("验证凭证生成失败");
        }
        const pending = this.pendingRequest;
        this.reset();
        pending.resolve(challengeToken);
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          "验证码错误，请重试";
        this.code = "";
      } finally {
        this.submitting = false;
      }
    },
    cancelChallenge() {
      this.rejectPending(new Error("安全验证已取消"));
    },
    handleClosed() {
      if (this.pendingRequest) {
        this.rejectPending(new Error("安全验证已取消"));
      }
    },
    rejectPending(error) {
      const pending = this.pendingRequest;
      this.reset();
      if (pending) {
        pending.reject(error);
      }
    },
    reset() {
      this.visible = false;
      this.loading = false;
      this.submitting = false;
      this.image = "";
      this.code = "";
      this.errorMessage = "";
      this.pendingRequest = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.challenge-body {
  min-height: 168px;
}

.challenge-tip {
  margin: 0 0 14px;
  color: #606266;
  font-size: 14px;
}

.challenge-image-button {
  display: block;
  width: 160px;
  height: 45px;
  margin: 0 auto 14px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
}

.challenge-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: none;
}

.challenge-error {
  margin: 10px 0 0;
  color: #f56c6c;
  font-size: 13px;
}
</style>
